import React, {Component} from "react";
import { Typography, Grid } from '@material-ui/core';
class GrafikBarTegak extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    

    render() { 
        const {data} = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item>
                    <div className="main-bg-abu-grafik">
                        <div style={{height: this.props.value, background: ''+this.props.color, borderRadius: 10}}></div>
                    </div>  
                </Grid>

                <Grid item style={{marginTop: 60}}>
                    <Typography variant="body2" color="textSecondary">{this.props.label}</Typography>
                    <Typography variant="body1" color="textPrimary" style={{fontWeight: 600}}>{this.props.value}</Typography>
                </Grid>
              
            </Grid>
        );
    }
}
 
export default GrafikBarTegak;